var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Time",
    clipPath: "url(#clip0_36571_67138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56111 3.11111V6.22222C5.56111 7.44645 6.55355 8.43889 7.77778 8.43889H10.8889V7.11667H7.77778C7.28379 7.11667 6.88333 6.71621 6.88333 6.22222V3.11111H5.56111Z",
    fill: "var(--secondary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM12.6778 7C12.6778 10.1357 10.1357 12.6778 7 12.6778C3.86425 12.6778 1.32222 10.1357 1.32222 7C1.32222 3.86425 3.86425 1.32222 7 1.32222C10.1357 1.32222 12.6778 3.86425 12.6778 7Z",
    fill: "var(--secondary-6)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36571_67138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "var(--white)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOutlined);
export default __webpack_public_path__ + "static/media/clockOutlined.077cc62aa9490548484f63a064aaf93b.svg";
export { ForwardRef as ReactComponent };